<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        v-if="!helpers.dataIsLoading && !hideHeader"
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >{{ title }}<v-spacer></v-spacer>
        <v-btn
          v-if="!hideDetailsBtn && showPerformanceTargetResult"
          text
          outlined
          small
          @click="toggleDetailsDialog"
          >Details anzeigen</v-btn
        >
      </v-card-title>

      <div>
        <v-row>
          <v-col cols="12">
            <v-card v-if="!noResult && showPerformanceTargetResult">
              <v-card-text class="pb-0">
                <!-- Overall Status Card -->
                <v-row dense>
                  <v-col>
                    <performance-target-personal-result-view
                      :total-status="performanceTargetResult.totalStatus"
                      :trafficLightStatus="
                        performanceTargetResult.trafficLightStatus
                      "
                    ></performance-target-personal-result-view>
                  </v-col>
                </v-row>

                <!-- Performance Targets List -->
                <div class="font-weight-bold my-2"></div>
                <v-row dense>
                  <v-col cols="12">
                    <performance-target-result-card
                      v-for="(
                        performanceTargetSingleResult, index
                      ) in performanceTargetResult.performanceTargets"
                      :key="index"
                      :result="performanceTargetSingleResult"
                      :use-default-style="useDefaultStyle"
                    ></performance-target-result-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Action Buttons -->
              <!-- <v-card-actions class="px-4 pb-4">
                <v-btn outlined small color="primary" @click="explainGap">
                  <v-icon left small>mdi-lightbulb-on-outline</v-icon>
                  Differenz verstehen
                </v-btn>
                <v-btn
                  outlined
                  small
                  color="primary"
                  @click="calculateForecast"
                >
                  <v-icon left small>mdi-chart-timeline-variant</v-icon>
                  Prognose berechnen
                </v-btn>
                <v-spacer></v-spacer>
                <v-chip small outlined>
                  <v-icon left small>mdi-clock-outline</v-icon>
                  {{ getTimeRemaining() }}
                </v-chip>
              </v-card-actions> -->

              <!-- Time Period Info -->
              <v-card-text
                v-if="performanceTargetResult?.meta?.lastCalculatedAt"
                class="pt-0 pb-3 grey--text text-caption"
              >
                <strong>Letzte Aktualisierung:</strong>
                {{
                  timestampConverter(
                    performanceTargetResult.meta.lastCalculatedAt
                  )
                }}
                Uhr
              </v-card-text>
            </v-card>
            <v-alert
              v-else
              border="left"
              colored-border
              type="error"
              transition="scale-transition"
              elevation="2"
              class="subtitle-2"
            >
              Zum aktuellen Zeitpunkt steht für Dich kein persönliches
              Berechnungsergebnis zum Abruf bereit.
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <CustomDialog
      v-if="helpers.detailsDialog.model"
      @close="toggleDetailsDialog()"
      title="Berechnungsdetails"
      fullscreenOnMobile
      width="l"
      hideActionBtn
      showCloseBtn
    >
      <template v-slot:content>
        <performance-target-results-details-content
          v-if="performanceTargetResult"
          :user-data="performanceTargetResult"
        ></performance-target-results-details-content>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { db, auth } from "@/firebase";
import PerformanceTargetPersonalResultView from "@/components/member-management/performance-targets/PerformanceTargetPersonalResultView.vue";
import PerformanceTargetResultCard from "@/components/member-management/performance-targets/PerformanceTargetResultCard.vue";
import PerformanceTargetResultsDetailsContent from "@/components/member-management/performance-targets/PerformanceTargetResultsDetailsDialog.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
export default {
  name: "self-service-performance-monitoring",
  props: {
    hideHeader: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Zielvorgaben",
    },
    hideDetailsBtn: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    PerformanceTargetPersonalResultView,
    PerformanceTargetResultCard,
    PerformanceTargetResultsDetailsContent,
    CustomDialog,
  },
  data() {
    return {
      useDefaultStyle: false,
      helpers: {
        dataIsLoading: false,

        detailsDialog: {
          model: false,
          data: null,
        },
      },
      currentUserUid: auth.currentUser.uid,
      noResult: false,
      performanceTargetResult: {},
    };
  },
  computed: {
    showPerformanceTargetResult() {
      return !this.$store.getters["organization/checkFeatureAvailabilityById"](
        "showPerformanceTargetResult"
      );
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("performanceTargetResults")
        // .where("user.uid", "==", "scLSuJqD2aYhID5qv32OHw6lodC2")
        .where("user.uid", "==", this.currentUserUid)
        .orderBy("meta.lastCalculatedAt", "desc")
        .limit(1)
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
              this.performanceTargetResult = doc.data();
            });
            this.helpers.dataIsLoading = false;
          } else {
            console.log("No performance target result found for user!");
            this.noResult = true;
            this.helpers.dataIsLoading = false;
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
          this.noResult = true;
          this.helpers.dataIsLoading = false;
        });
    },
    timestampConverter(timestamp, includeTime = true) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      if (includeTime) {
        options.hour = "2-digit";
        options.minute = "2-digit";
      }
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    getTimeRemaining() {
      if (!this.activePerformanceTargetResult.calculationParameters) {
        return "–";
      }
      const endDate =
        this.activePerformanceTargetResult.calculationParameters.customCalculationEndDate.toDate();
      const now = new Date();
      const diffTime = endDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        return "Zeitraum abgelaufen";
      } else if (diffDays === 0) {
        return "Endet heute";
      } else if (diffDays === 1) {
        return "1 Tag verbleibend";
      } else {
        return `${diffDays} Tage verbleibend`;
      }
    },
    async toggleDetailsDialog(item) {
      if (item) {
        this.helpers.detailsDialog.data = item;
      }
      this.helpers.detailsDialog.model = !this.helpers.detailsDialog.model;
    },
    showTargetDetails(target) {
      console.log("Show details for:", target);
      // TODO: Navigate to detailed view or show dialog
      this.$router.push({
        name: "member-management-performance-targets-overview",
        params: {
          organizationId: this.$route.params.organizationId,
        },
        query: {
          targetId: target.performanceTarget.id,
        },
      });
    },
    explainGap() {
      console.log("Explain gap functionality");
      // TODO: Show dialog explaining the difference between actual and target
      alert(
        "Diese Funktion zeigt Dir eine detaillierte Analyse der Differenz zwischen Ist- und Soll-Werten."
      );
    },
    calculateForecast() {
      console.log("Calculate forecast functionality");
      // TODO: Calculate and show forecast based on current trajectory
      alert(
        "Diese Funktion berechnet eine Prognose basierend auf Deiner aktuellen Leistung."
      );
    },
  },
};
</script>
